import { render } from "./ShareWithUsersForm.vue?vue&type=template&id=483d59f4"
import script from "./ShareWithUsersForm.vue?vue&type=script&lang=ts"
export * from "./ShareWithUsersForm.vue?vue&type=script&lang=ts"
script.render = render

export default script